export default __webpack_public_path__ + "static/media/egg.b575c94d.jpeg";